<template>
  <div>
    <span>{{ value }}</span>
  </div>
</template>

<script>
import moment from 'moment';
import BaseControlMixin from '@/components/controls/mixins/BaseControl';

export default {
  name: 'TimeDisplayField',
  mixins: [
    BaseControlMixin,
  ],
  computed: {
    value() {
      if (this.getSingleVar.value) {
        return moment.utc(this.getSingleVar.value).format('LT');
      }
      return this.$t('not-available');
    },
  },
};
</script>

<style scoped>

</style>
